import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchActiveFnPrd,
  fetchFiscPeriod,
  fetchPrItem,
  fetchPrWefDtls,
} from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";
import { monthsData } from "../../../../data";
import moment from "moment";
import dayjs from "dayjs";
import InsideHeader from "../../../../components/InsideHeader";

const { TextArea } = Input;

const AddWef = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fiscalP, loading, prItem, activeFnPrd, prWefDtls } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.save);

  const { personnelFolders, wefObj } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(wefObj);
  const [formDatadtl, setFormDatadtl] = useState(prWefDtls);

  const [data, setdata] = useState({});

  const onChange = async (e) => {
    const { name, value } = e.target; 
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        [name]: value,
      }; 
      if (name === "wefhPrd") {
        const d = new Date();
        d.setFullYear(parseInt(updatedFormData.wefhStartYear), parseInt(updatedFormData.wefhStartMonth) - 1, 1);
  
        const endDate = new Date(d.setMonth(d.getMonth() + parseInt(value)));
        updatedFormData.wefhEndYear = endDate.getFullYear();
        updatedFormData.wefhEndMonth =String(endDate.getMonth());  
      }
  
      return updatedFormData;
    });
  };
   

  const onChangeOther = (value, fieldName) => {
    setFormDatadtl((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  async function handleSelectChangedtl(value, formName) {
    await setFormDatadtl((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.ppId) {
      toast.error("Please select personnel");
      return;
    }
    if (!formDatadtl?.itemcode) {
      toast.error("Please select item details");
      return;
    }
    if (!formDatadtl?.wefdAmount) {
      toast.error("Please add details amount");
      return;
    }

    const res = await dispatch(
      save({
        wefhId: wefObj?.wefhId ? wefObj?.wefhId : null,
        wefhNo: formData?.wefhNo,
        wefhDesc: formData?.wefhDesc,
        ppId: formData?.ppId,
        wefhEntryDate: formData?.wefhEntryDate,
        fpPyear: activeFnPrd?.fpPyear,
        fpPmonth: activeFnPrd?.fpPmonth,
        wefhStartYear: formData?.wefhStartYear,
        wefhStartMonth: formData?.wefhStartMonth,
        wefhPrd: formData?.wefhPrd,
        wefhEndYear: formData?.wefhEndYear,
        wefhEndMonth: formData?.wefhEndMonth,
 

        url: "hr/savePrWef.action",
      })
    ); 
    if (res?.payload?.success) {
        const res1 = await dispatch(save({
        wefhId: res?.payload?.data?.savedWefhId,
        wefdId:prWefDtls?.wefdId ? prWefDtls?.wefdId : null,
        itemcode: formDatadtl?.itemcode,
        wefdAmount: formDatadtl?.wefdAmount,
        url: "hr/savePrWefDetails.action",
      }))
      if(res1?.payload?.success){ 
        await toast.success(res1?.payload?.messages?.message);
        await setFormData({});
        await form.resetFields();
        await navigate('/wef-entries')
      }

    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData() {
    dispatch(fetchPersonnelFolders());
  }

  async function fetchPrItemData() {
    dispatch(fetchPrItem());
  }

  async function fetchFiscPeriodData() {
    dispatch(fetchFiscPeriod());
  }

  useEffect(() => {
    setFormData({
      ...formData,
      wefhStartMonth:wefObj?.wefhStartMonth ?  String(wefObj?.wefhStartMonth) : null,   
      wefhEndMonth:wefObj?.wefhEndMonth ? String(wefObj?.wefhEndMonth) : null,
    }); 
  }, [wefObj]);

  

  useEffect(() => {
    setFormDatadtl(prWefDtls);
  }, [prWefDtls]);

  useEffect(() => {
    dispatch(fetchActiveFnPrd());
    fetchFiscPeriodData()
    dispatch(fetchPrWefDtls({
      wefhId_id:wefObj?.wefhId
    }));
  }, []);

 

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="W.E.F Details"
        subtitle="Manage W.E.F Details within your institution"
        back={true}
        title1="W.E.F Details"
        title2="W.E.F Add"
      />

      <div className="lg:px-10 px-3 bg-white mt-[1.25rem] pb-5 rounded-[10px] ">
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" w-full lg:w-[61.25rem]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="flex items-center gap-x-5">
            <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
              <span className="paragraph_paragraph_bb08">1</span>
            </div>
            <span className="paragraph_paragraph_bb13">W.E.F Header</span>
          </div>

          <div className="grid grid-cols-2 gap-x-5 my-5">
            <Form.Item
              label="W.E.F No"
              rules={[
                {
                  required: true,
                  message: "Enter wef no",
                },
              ]}
            >
              <Input
                readOnly={true}
                name="wefhNo"
                onChange={onChange}
                value={formData?.wefhNo}
                className="input"
              />
            </Form.Item>
            <Form.Item
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Add description",
                },
              ]}
            >
              <Input
                name="wefhDesc"
                onChange={onChange}
                value={formData?.wefhDesc}
                className="input"
              />
            </Form.Item>
            <Form.Item
              className=""
              label={<span>Staff</span>}
              rules={[
                {
                  required: true,
                  message: "Please select staff",
                },
              ]}
            >
              <Select
                name="ppId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  personnelFolders?.length > 0 &&
                  personnelFolders?.map((item) => ({
                    value: item?.ppId,
                    label: item?.ppPfno + " - " + item?.ppFullname,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "ppId");
                }}
                value={formData?.ppId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchPersonnelData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: false,
                  message: "Field is required",
                },
              ]}
              label="Date"
            >
              <DatePicker
                name="wefhEntryDate"
                className="input"
                placeholder={
                  formData?.wefhEntryDate
                    ? moment(formData.wefhEntryDate)?.format("DD-MM-YYYY")
                    : "Select Date"
                }
                value={
                  formData?.wefhEntryDate ? dayjs(formData.wefhEntryDate) : null
                }
                format={"DD-MM-YYYY"}
                onChange={(value) => {
                  onMonthChange(value, "wefhEntryDate");
                }}
              />
            </Form.Item>

            <Form.Item
              label="Fiscal Year"
              rules={[
                {
                  required: true,
                  message: "Enter Fiscal Year",
                },
              ]}
            >
              <Input
                readOnly={true}
                name="fpPyear"
                onChange={onChange}
                value={activeFnPrd?.fpPyear}
                className="input"
              />
            </Form.Item>

            <Form.Item
              label="Period"
              rules={[
                {
                  required: true,
                  message: "Enter period",
                },
              ]}
            >
              <Input
                readOnly={true}
                name="fpPmonth"
                onChange={onChange}
                value={activeFnPrd?.fpPmonth}
                className="input"
              />
            </Form.Item>

            <Form.Item
              className=""
              label="Start Year"
              rules={[
                {
                  required: true,
                  message: "Please select start year",
                },
              ]}
            >
              <Select
                name="wefhStartYear"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  fiscalP?.length > 0 &&
                  fiscalP?.map((item) => ({
                    value: item?.fpPyear,
                    label: item?.fpPyear,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "wefhStartYear");
                }}
                value={formData?.wefhStartYear}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchFiscPeriodData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label="Period"
              rules={[
                {
                  required: true,
                  message: "Please select Period",
                },
              ]}
            >
              <Select
                name="wefhStartMonth"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  monthsData?.length > 0 &&
                  monthsData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "wefhStartMonth");
                }}
                value={formData?.wefhStartMonth}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                // onDropdownVisibleChange={() => {
                //   fetchFiscPeriodData();
                // }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              extra={"i.e running in months"}
              label="Months"
              rules={[
                {
                  required: true,
                  message: "Enter period",
                },
              ]}
            >
              <Input
                name="wefhPrd"
                onChange={onChange}
                value={formData?.wefhPrd}
                className="input"
              />
            </Form.Item>
            <Form.Item
              className=""
              label="End Year"
              rules={[
                {
                  required: true,
                  message: "Please select end year",
                },
              ]}
            >
              <Select
                name="wefhEndYear"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  fiscalP?.length > 0 &&
                  fiscalP?.map((item) => ({
                    value: item?.fpPyear,
                    label: item?.fpPyear,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "wefhEndYear");
                }}
                value={formData?.wefhEndYear}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchFiscPeriodData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label="Period"
              rules={[
                {
                  required: true,
                  message: "Please select Period",
                },
              ]}
            >
              <Select
                name="wefhEndMonth"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  monthsData?.length > 0 &&
                  monthsData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "wefhEndMonth");
                }}
                value={formData?.wefhEndMonth}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                // onDropdownVisibleChange={() => {
                //   fetchFiscPeriodData();
                // }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>
          </div>

          <div className="flex items-center gap-x-5">
            <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
              <span className="paragraph_paragraph_bb08">2</span>
            </div>
            <span className="paragraph_paragraph_bb13">W.E.F Details</span>
          </div>

          <div className="mt-5">
            <Form.Item
              className=""
              label="Item Details"
              rules={[
                {
                  required: true,
                  message: "Please select Item Details",
                },
              ]}
            >
              <Select
                name="itemcode"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  prItem?.length > 0 &&
                  prItem?.map((item) => ({
                    value: item?.piItemcode,
                    label: item?.piItemname,
                  }))
                }
                onChange={(value) => {
                  handleSelectChangedtl(value, "itemcode");
                }}
                value={formDatadtl?.itemcode}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchPrItemData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className="table-form-item"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Please add amount",
                },
              ]}
            >
              <InputNumber
                name="wefdAmount"
                value={formDatadtl?.wefdAmount}
                onChange={(value) => onChangeOther(value, "wefdAmount")}
                min={0} 
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")} 
                className="input flex"
              />
            </Form.Item>
          </div>

          <div className="justify-center  flex flex-col mt-10 items-center gap-y-2">
            <div className="w-[200px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn"
                disabled={saving}
              >
                {saving ? <Spin /> : "Create"}
              </button>
            </div>
            <div className="w-[200px]">
              <button
                key="back"
                type="button"
                onClick={() => navigate(-1)}
                className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
              >
                Cancel
              </button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default AddWef;
